const PREFIX = 'BIXI';

export const EVENTS = {
  ready: `${PREFIX}_READY`,
  startLabeling: `${PREFIX}_START_LABELING`,
  deleteLabels: `${PREFIX}_DELETE_LABELS`,
  paginationChange: `${PREFIX}_PAGINATION_CHANGE`,
  zoomChange: `${PREFIX}_ZOOM_CHANGE`,
  searchResult: `${PREFIX}_SEARCH_RESULT`,
  clickLabels: `${PREFIX}_CLICK_LABELS`,
  hoverInLabel: `${PREFIX}_HOVER_IN_LABEL`,
  hoverOutLabel: `${PREFIX}_HOVER_OUT_LABEL`,
  pdfScrolling: `${PREFIX}_PDF_SCROLLING`,
  pdfLoadFailed: `${PREFIX}_PDF_LOAD_FAILED`,
  resize: `${PREFIX}_resize`,
  log: `${PREFIX}_LOG`,
  mergeTables: `${PREFIX}_MERGE_TABLES`,
  splitTable: `${PREFIX}_SPLIT_TABLE`,
  tblOperationRecords: `${PREFIX}_TABLE_OPERATION_RECORDS`
};

